import gql from 'graphql-tag'

const GET_CART = gql`
  query Cart($id: String!) {
    cart(id: $id) {
      id
      siteUrl
      cartItems {
        id
        quantity
        variationId
        product {
          id
          description
          name
          price
          offerPrice
          quantity
          manageStock
          requiresShipping
          photos {
            id
            position
            settings {
              src
              title
              thumbnails {
                medium {
                  src
                }
                small {
                  src
                }
              }
            }
          }
          variations {
            id
            quantity
          }
          weight
        }
      }
    }
  }
`

export { GET_CART }
